import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import MonteurDashboard from "@/pages/MonteurDashboard";
import BedrijfDashboard from "@/pages/BedrijfDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentReturn from "@/pages/PaymentReturn";
import OfferteAanvragen from "@/pages/OfferteAanvragen";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import ExtendItem from "@/pages/ExtendItem";
import PublicJobs from "@/pages/PublicJobs";
import PublicMonteurs from "@/pages/PublicMonteurs";
import RegioLanding from "@/pages/RegioLanding";

function Protected({ role, roles, children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Laden...
      </div>
    );
  if (!user) return <Navigate to="/inloggen" replace />;
  const allowed = roles || (role ? [role] : null);
  if (allowed && !allowed.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user?.role === "monteur") return <Navigate to="/monteur" replace />;
  if (user?.role === "bedrijf" || user?.role === "particulier") return <Navigate to="/opdrachtgever" replace />;
  if (user?.role === "admin") return <Navigate to="/admin" replace />;
  return <Landing />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeRedirect />} />
            <Route path="/inloggen" element={<Auth mode="login" />} />
            <Route path="/registreren" element={<Auth mode="register" />} />
            <Route path="/wachtwoord-vergeten" element={<ForgotPassword />} />
            <Route path="/wachtwoord-herstellen" element={<ResetPassword />} />
            <Route path="/e-mail-bevestigen" element={<VerifyEmail />} />
            <Route path="/opdracht-verlengen" element={<ExtendItem />} />
            <Route path="/offerte-aanvragen" element={<OfferteAanvragen />} />
            <Route path="/opdrachten" element={<PublicJobs />} />
            <Route path="/beschikbare_monteurs" element={<PublicMonteurs />} />
            <Route path="/regio/:slug" element={<RegioLanding />} />
            <Route path="/monteurs" element={<Navigate to="/beschikbare_monteurs" replace />} />
            <Route
              path="/monteur"
              element={
                <Protected role="monteur">
                  <MonteurDashboard />
                </Protected>
              }
            />
            <Route
              path="/opdrachtgever"
              element={
                <Protected roles={["bedrijf", "particulier"]}>
                  <BedrijfDashboard />
                </Protected>
              }
            />
            <Route path="/bedrijf" element={<Navigate to="/opdrachtgever" replace />} />
            <Route path="/betaling-succes" element={<Protected roles={["monteur", "bedrijf", "particulier"]}><PaymentReturn /></Protected>} />
            <Route path="/betaling-geannuleerd" element={<Protected roles={["monteur", "bedrijf", "particulier"]}><PaymentReturn cancelled /></Protected>} />
            <Route
              path="/admin"
              element={
                <Protected role="admin">
                  <AdminDashboard />
                </Protected>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
